import React from 'react';
import { Navbar, Nav, Dropdown, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { 
  FaBars, 
  FaUser, 
  FaSignOutAlt, 
  FaUserCircle 
} from 'react-icons/fa';
import { useAuth } from '../../hooks/useAuth';
import { toast } from 'react-toastify';

const Header = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      toast.success('Çıkış başarılı!');
      navigate('/login');
    } catch (error) {
      toast.error('Çıkış yapılırken bir hata oluştu.');
    }
  };

  const getRoleText = (role) => {
    const roleMap = {
      'admin': 'Yönetici',
      'visa_office': 'Danışmanlık Firması',
      'user': 'Kullanıcı'
    };
    return roleMap[role] || role;
  };

  return (
    <Navbar bg="white" expand="lg" className="navbar px-4 py-3">
      <div className="d-flex align-items-center flex-grow-1">
        {/* Mobile Menu Button */}
        <Button
          variant="link"
          className="d-md-none me-3 text-dark"
          onClick={toggleSidebar}
        >
          <FaBars size={20} />
        </Button>

        {/* Page Title */}
        <Navbar.Brand className="mb-0 h1 text-dark">
          Visa Panel
        </Navbar.Brand>

        {/* Right Side */}
        <Nav className="ms-auto d-none d-md-flex">
          <Dropdown align="end">
            <Dropdown.Toggle 
              as="div" 
              className="d-flex align-items-center"
              style={{ 
                cursor: 'pointer',
                padding: '4px 8px',
                borderRadius: '8px',
                transition: 'background-color 0.2s',
                margin: '-4px 0'
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
            >
              <div className="d-flex align-items-center">
                <FaUserCircle size={32} className="text-primary" style={{ minWidth: '32px' }} />
                <div className="text-start d-none d-sm-block ms-2">
                  <div className="fw-semibold text-dark" style={{ fontSize: '14px' }}>
                    {user?.first_name} {user?.last_name}
                  </div>
                  <small className="text-muted" style={{ fontSize: '12px' }}>
                    {getRoleText(user?.role)}
                  </small>
                </div>
              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu 
              className="shadow border-0"
              style={{
                minWidth: '280px',
                marginTop: '8px'
              }}
            >
              <Dropdown.Header className="py-3">
                <div className="d-flex align-items-center">
                  <FaUserCircle size={32} className="text-primary me-3" />
                  <div>
                    <div className="fw-semibold" style={{ fontSize: '15px' }}>
                      {user?.first_name} {user?.last_name}
                    </div>
                    <small className="text-muted" style={{ fontSize: '13px' }}>
                      {user?.email}
                    </small>
                  </div>
                </div>
              </Dropdown.Header>
              
              <Dropdown.Divider />
              
              <Dropdown.Item 
                onClick={() => navigate('/profile')}
                className="d-flex align-items-center py-3"
                style={{ fontSize: '15px' }}
              >
                <FaUser className="me-3" size={16} />
                Profil
              </Dropdown.Item>
              
              <Dropdown.Divider />
              
              <Dropdown.Item 
                onClick={handleLogout}
                className="d-flex align-items-center text-danger py-3"
                style={{ fontSize: '15px' }}
              >
                <FaSignOutAlt className="me-3" size={16} />
                Çıkış Yap
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Nav>
      </div>
    </Navbar>
  );
};

export default Header; 